import axiosInstance from "api/axiosInstance";

import type { AdminOrder, AdminOrderCancelResponse, AdminOrderListParams, NaverOrderRegisterRequest, NaverOrderRegisterResponse, OrderBulkUpdateRequest, OrderBulkUpdateResponse, OrderDashboardStats, OrderFulfillmentUpdateRequest, OrderFulfillmentUpdateResponse } from "api/types/order.types";
import type { PaginatedResponse } from "api/types/product.types";

const BASE = "/server/buccl_main/api/v1/admin/orders/";
const NAVER_ORDER_BASE = "/server/buccl_main/api/v1/admin/naver-order/";

export const ordersService = {
  list: (params?: AdminOrderListParams) => axiosInstance.get<PaginatedResponse<AdminOrder>>(BASE, { params }),

  get: (id: number) => axiosInstance.get<AdminOrder>(`${BASE}${id}/`),

  // 주문 취소: PG 환불 + (PRODUCT) 재고 복구 + 취소 감사 기록
  cancel: (id: number, cancelReason: string) =>
    axiosInstance.post<AdminOrderCancelResponse>(`${BASE}${id}/cancel/`, {
      cancel_reason: cancelReason,
    }),

  updateFulfillment: (id: number, payload: OrderFulfillmentUpdateRequest) => axiosInstance.patch<OrderFulfillmentUpdateResponse>(`${BASE}${id}/fulfillment/`, payload),

  bulkUpdate: (payload: OrderBulkUpdateRequest) => axiosInstance.patch<OrderBulkUpdateResponse>(`${BASE}bulk-update/`, payload),

  getDashboardStats: () => axiosInstance.get<OrderDashboardStats>(`${BASE}dashboard/stats/`),

  exportExcel: (params?: AdminOrderListParams) => axiosInstance.get<Blob>(`${BASE}export/excel/`, { params, responseType: "blob" }),

  registerNaverOrder: (payload: NaverOrderRegisterRequest) => axiosInstance.post<NaverOrderRegisterResponse>(NAVER_ORDER_BASE, payload),
};
